import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Checkbox', null, {
    withChildren: true,
    // eslint-disable-next-line react/display-name
    innerDependence: ({
        children,
        invalid,
        innerRef,
        openingContent,
        indeterminate,
        source,
        labelProps,
        wrapperProps,
        ...checkboxProps
    }) => <input {...checkboxProps} type="checkbox" />,
});
